/**
 * Builds a tel: href that dials a number and, if present, an extension.
 * Extension digits are appended after two commas — each comma is a DTMF pause
 * (~2s) most mobile dialers honor, unlike the RFC 3966 ;ext= syntax which
 * iOS/Android often ignore.
 * @param numberDigits - The phone number as digits only.
 * @param extensionDigits - The extension as digits only, if any.
 * @returns {string} The tel: href to dial.
 */
export function buildTelHref(numberDigits: string, extensionDigits?: string): string {
  return extensionDigits ? `tel:${numberDigits},,${extensionDigits}` : `tel:${numberDigits}`;
}
